import { fetchIStatus } from '@/shared/fetchIStatus';
import { IOpenDietitianAttachmentConsultationRequest } from '@/shared/interfaces';

export const createDietitianAttachmentConsultation = async (
    openDietitianAttachmentConsultationRequest: IOpenDietitianAttachmentConsultationRequest,
) => {
    return await fetchIStatus<
        string,
        IOpenDietitianAttachmentConsultationRequest
    >(
        `/api/consultations/message`,
        'POST',
        openDietitianAttachmentConsultationRequest,
    );
};
